import styled from 'styled-components'

const BilansStyle = styled.div`
  grid-area: main;
  background-color: ${props => props.theme.black4};
  padding: 0 12px 12px;

  input {
    text-align: right;
  }

  .container {
    height: 74vh;
    overflow: auto;
    #pasywa {
      margin-top: 56px;
    }
  }
  .container.rzis {
    height: 83vh;
  }
  .wariantRZiS {
    max-width: 422px;
  }
`

export default BilansStyle
